/**
 * Провайдер листа — до чого лист і чиї змінні в шаблоні (`SPEC-013` §4.3).
 *
 * Копія беківського enum `Ship/Database/Enum/LetterProvider.php`. Значення
 * звіряє вартовий В-6 (`Ship/Helpers/architectureGuard.test.ts`): новий
 * провайдер у беку без опції тут — падіння, а не сирий код у таблиці.
 *
 * Живе в Ship, бо його читають довідник «Шаблони листів» і кнопки листа в
 * картках клієнта, перевізника, контактів і документів (S8b). Порядок —
 * порядок опцій select (легасі `sorting` 10–100); етап 2 (`SPEC-025` §3.2)
 * додав запити, тендери, заявки й документи заявок — підписи легасі.
 */
export type LetterProviderValue =
    | 'client'
    | 'client_contact'
    | 'client_document'
    | 'carrier'
    | 'carrier_contact'
    | 'carrier_document'
    | 'request'
    | 'tender'
    | 'application'
    | 'application_document'

export interface LetterProviderOption {
    value: LetterProviderValue
    label: string
}

export const LETTER_PROVIDER_OPTIONS: LetterProviderOption[] = [
    { value: 'client', label: 'Клієнт' },
    { value: 'client_contact', label: 'Контакти клієнта' },
    { value: 'client_document', label: 'Документи клієнта' },
    { value: 'carrier', label: 'Перевізник' },
    { value: 'carrier_contact', label: 'Контакти перевізника' },
    { value: 'carrier_document', label: 'Документи перевізника' },
    { value: 'request', label: 'Запити' },
    { value: 'tender', label: 'Тендер' },
    { value: 'application', label: 'Заявки' },
    { value: 'application_document', label: 'Документи заявок' },
]
